'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ActivationErrorModal from '../../common/components/activation/ActivationErrorModal';
import { TEMPORARY_REMOTE_TOOLS } from 'self-service-api/constants/UpgradeProducts';
import RemoteToolsActivationErrorModal from './RemoteToolsActivationErrorModal';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import TrialActivationSuccessContainer from './TrialActivationSuccessContainer';
import { activateTrial } from './activateTrial';
import { refreshCookie } from 'hub-http/auth';
import PortalIdParser from 'PortalIdParser';
var STATUSES = {
  LOADING: 'loading',
  ERROR: 'error',
  SUCCESS: 'success'
};
var HIDE_SUBTITLE_SCREENS = ['products-plans', 'remote-tools-page', 'service-hub-paywall'];

var TrialActivationModalContainer = /*#__PURE__*/function (_Component) {
  _inherits(TrialActivationModalContainer, _Component);

  function TrialActivationModalContainer(props) {
    var _this;

    _classCallCheck(this, TrialActivationModalContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TrialActivationModalContainer).call(this, props));
    _this.state = {
      trialActivationRequestStatus: STATUSES.LOADING,
      error: null,
      showTrialLoadingState: !!props.shouldHideSurvey
    };
    return _this;
  }

  _createClass(TrialActivationModalContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;
      var upgradeData = this.props.upgradeData;
      activateTrial(upgradeData).then(function () {
        if (_this2._isMounted) {
          _this2.setState({
            trialActivationRequestStatus: STATUSES.SUCCESS
          });

          setTimeout(function () {
            refreshCookie(PortalIdParser.get(), true);

            _this2.setState({
              showTrialLoadingState: false
            });
          }, 3000);
        }
      }).catch(function (err) {
        if (_this2._isMounted) {
          _this2.setState({
            trialActivationRequestStatus: STATUSES.ERROR,
            error: err
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          trialActivationRequestStatus = _this$state.trialActivationRequestStatus,
          error = _this$state.error,
          showTrialLoadingState = _this$state.showTrialLoadingState;

      var _this$props = this.props,
          upgradeData = _this$props.upgradeData,
          _this$props$upgradeDa = _this$props.upgradeData,
          upgradeProduct = _this$props$upgradeDa.upgradeProduct,
          screen = _this$props$upgradeDa.screen,
          onSuccess = _this$props.onSuccess,
          shouldHideSurvey = _this$props.shouldHideSurvey,
          successModalPassthroughProps = _objectWithoutProperties(_this$props, ["upgradeData", "upgradeData", "onSuccess", "shouldHideSurvey"]);

      var showSubtitle = !HIDE_SUBTITLE_SCREENS.includes(screen);

      switch (trialActivationRequestStatus) {
        case STATUSES.LOADING:
          return null;

        case STATUSES.ERROR:
          // Temporary for remote tools error message
          if (upgradeProduct === TEMPORARY_REMOTE_TOOLS && error) {
            return React.createElement(RemoteToolsActivationErrorModal, {
              error: error,
              onSuccess: onSuccess
            });
          }

          return React.createElement(ActivationErrorModal, null);

        case STATUSES.SUCCESS:
          return React.createElement(TrialActivationSuccessContainer, Object.assign({
            onSuccess: onSuccess,
            upgradeData: upgradeData,
            showTrialLoadingState: showTrialLoadingState,
            showSubtitle: showSubtitle,
            shouldHideSurvey: shouldHideSurvey
          }, successModalPassthroughProps));

        default:
          return null;
      }
    }
  }]);

  return TrialActivationModalContainer;
}(Component);

TrialActivationModalContainer.defaultProps = {
  hideBackground: false
};
TrialActivationModalContainer.propTypes = Object.assign({
  hideBackground: PropTypes.bool,
  onSuccess: PropTypes.func,
  shouldHideSurvey: PropTypes.bool,
  successModalHeader: PropTypes.node,
  successModalSubText: PropTypes.node,
  successModalCtaText: PropTypes.node,
  showSuccessModalIllustration: PropTypes.bool
}, upgradeDataPropsInterface);
export default TrialActivationModalContainer;